import { ThreeCircles } from "react-loader-spinner";
export const Loader = () => {
  return (
    <div className="d-flex align-items-center justify-content-center h-100">
      <ThreeCircles
        visible={true}
        height="100"
        width="100"
        color="#106f60"
        ariaLabel="three-circles-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
};
